import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Bell, Flame, PlayCircle, MessageSquare } from "lucide-react";
import { api } from "../lib/api";
import { fmtDate } from "../lib/format";

export default function NotificationBell({ variant = "mobile" }) {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [data, setData] = useState({ notifications: [], unread: 0 });

  const load = () => api.get("/notifications").then((r) => setData(r.data)).catch(() => {});
  useEffect(() => {
    load();
    const iv = setInterval(load, 30000);
    return () => clearInterval(iv);
  }, []);

  const openItem = async (n) => {
    if (!n.read) await api.post(`/notifications/${n.id}/read`).catch(() => {});
    setOpen(false);
    load();
    navigate(n.link || `/quotes/${n.quote_id}/edit`);
  };
  const readAll = async () => { await api.post("/notifications/read-all").catch(() => {}); load(); };
  const pos = variant === "desktop" ? "fixed top-[4.25rem] left-4" : "fixed top-16 left-3";

  return (
    <>
      <button data-testid={`notif-bell-${variant}`} title="Notifiche" onClick={() => setOpen((v) => !v)}
        className="relative w-8 h-8 rounded-lg border border-slate-200 bg-card text-slate-500 hover:text-primary hover:border-primary/40 flex items-center justify-center transition-colors">
        <Bell style={{ width: 15, height: 15 }} />
        {data.unread > 0 && (
          <span data-testid={`notif-unread-${variant}`} className="absolute -top-1.5 -right-1.5 min-w-[18px] h-[18px] px-1 rounded-full bg-orange-500 text-white text-[10px] font-bold flex items-center justify-center">{data.unread}</span>
        )}
      </button>
      {open && (
        <div data-testid="notif-panel" className={`${pos} z-50 w-[22rem] max-w-[calc(100vw-1.5rem)] rounded-2xl bg-card border border-slate-200 shadow-2xl overflow-hidden`}>
          <div className="px-4 py-3 border-b border-slate-100 flex items-center justify-between">
            <p className="font-semibold text-slate-900 text-sm">Notifiche</p>
            {data.unread > 0 && <button data-testid="notif-read-all" onClick={readAll} className="text-xs font-semibold text-primary hover:underline">Segna tutte come lette</button>}
          </div>
          <div className="max-h-96 overflow-y-auto divide-y divide-slate-100">
            {data.notifications.length === 0 && <p className="px-4 py-8 text-center text-sm text-slate-400" data-testid="notif-empty">Nessuna notifica. Ti avviseremo quando un lead diventa caldo.</p>}
            {data.notifications.map((n) => (
              <button key={n.id} data-testid={`notif-item-${n.id}`} onClick={() => openItem(n)}
                className={`w-full text-left px-4 py-3 flex gap-3 hover:bg-slate-50 transition-colors ${n.read ? "" : "bg-orange-50/60"}`}>
                <span className={`w-8 h-8 rounded-full flex items-center justify-center shrink-0 ${n.type === "pause_unlock" ? "bg-emerald-100 text-emerald-600" : "bg-orange-100 text-orange-600"}`}>
                  {n.type === "pause_unlock" ? <PlayCircle style={{ width: 16, height: 16 }} /> : n.type === "revision_request" ? <MessageSquare style={{ width: 16, height: 16 }} /> : <Flame style={{ width: 16, height: 16 }} />}
                </span>
                <span className="min-w-0">
                  <span className="block text-sm font-semibold text-slate-900">{n.title}</span>
                  <span className="block text-xs text-slate-600">{n.message}</span>
                  <span className="block text-[11px] text-slate-400 mt-0.5">{fmtDate(n.created_at)}</span>
                </span>
              </button>
            ))}
          </div>
        </div>
      )}
    </>
  );
}
